import { View, SxProp } from 'dripsy';

import React from 'react';
import { TextAmount, TextCaption, TextSmall } from '@/design-system/components/typography';

interface AmountWithIndicativeProps {
  label: string;
  amount: string;
  currency: string;
  indicative: string;
  sx?: SxProp;
  success?: boolean;
}

export const AmountWithIndicative: React.FC<AmountWithIndicativeProps> = (props) => {
  const { label, amount, currency, indicative, sx, success } = props;

  return (
    <View sx={{ ...styles.container, ...sx }}>
      <TextCaption secondary label>
        {label}
      </TextCaption>
      <TextAmount size="H6" weight="bold" currency={currency} success={success}>
        {amount}
      </TextAmount>
      <TextAmount size="textSmall" currency="USD" prefix="≈" secondary>
        {indicative}
      </TextAmount>
    </View>
  );
};

enum StyleName {
  container = 'container'
}

const styles: Record<StyleName, SxProp> = {
  container: {}
};
